import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RptPrdJobHistoryComponent } from './rpt-prd-job-history/rpt-prd-job-history.component';
import { RptPrdProdWiseManufacturingComponent } from './rpt-prd-prod-wise-manufacturing/rpt-prd-prod-wise-manufacturing.component';

const routes: Routes = [
  { path: 'RptPrdJobHistory', component: RptPrdJobHistoryComponent },
  { path: 'RptPrdProdWiseManufacturing', component: RptPrdProdWiseManufacturingComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductionReportsRoutingModule { }
   